/**
 * @see docs/APP_UI_SPEC.md — F2 (`/admin_clubs` + `clubsAdminOnly` guard), G1 (public `/` vs `/apply`)
 */
import { createRouter, createWebHistory } from 'vue-router';
import EventList from '../components/EventList.vue';
import LandingPage from '../components/LandingPage.vue';
import PublicHome from '../components/PublicHome.vue';
import ForVenuesPage from '../components/ForVenuesPage.vue';
import VenueEventList from '../components/VenueEventList.vue';
import AdminPage from '../components/AdminPage.vue';
import AdminComicsPage from '../components/AdminComicsPage.vue';
import AdminDatesPage from '../components/AdminDatesPage.vue';
import AdminRotaPage from '../components/AdminRotaPage.vue';
import AdminInboxReviewPage from '../components/AdminInboxReviewPage.vue';
import AdminClubsPage from '../components/AdminClubsPage.vue';
import { isAdminAuthenticated } from '../utils/auth.js';
import { getCurrentUser } from '../utils/supabaseAuth.js';
import { emailIsInboxAdmin } from '../utils/inboxAdminAccess.js';
import { emailIsClubsAdmin } from '../utils/clubsAdminAccess.js';
import { applyDocumentTitle } from '../utils/documentTitle.js';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: PublicHome,
  },
  {
    path: '/apply',
    name: 'Apply',
    component: LandingPage,
  },
  {
    path: '/for-venues',
    name: 'ForVenues',
    component: ForVenuesPage,
  },
  {
    path: '/sunset',
    name: 'Sunset',
    component: VenueEventList,
    props: { venueSlug: 'sunset' }
  },
  {
    path: '/craicup',
    name: 'Craicup',
    component: VenueEventList,
    props: { venueSlug: 'craicup' }
  },
  {
    path: '/studio48',
    name: 'Studio48',
    component: VenueEventList,
    props: { venueSlug: 'studio48' }
  },
  {
    path: '/legacy',
    name: 'Legacy',
    component: EventList,
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin_comics',
    name: 'AdminComics',
    component: AdminComicsPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin_dates',
    name: 'AdminDates',
    component: AdminDatesPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin_rota',
    name: 'AdminRota',
    component: AdminRotaPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin_inbox',
    name: 'AdminInbox',
    component: AdminInboxReviewPage,
    meta: { requiresAuth: true, inboxAdminOnly: true },
  },
  {
    path: '/admin_clubs',
    name: 'AdminClubs',
    component: AdminClubsPage,
    meta: { requiresAuth: true, clubsAdminOnly: true },
  },
  {
    path: '/:venueSlug',
    name: 'VenueNight',
    component: VenueEventList,
    props: (route) => ({ venueSlug: route.params.venueSlug }),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation guard for admin routes
router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    const authenticated = await isAdminAuthenticated();
    if (!authenticated) {
      next({ name: 'Apply', query: { auth: 'required', redirect: to.path } });
      return;
    }
    if (to.meta.inboxAdminOnly) {
      const user = await getCurrentUser();
      if (!emailIsInboxAdmin(user?.email)) {
        next({ name: 'Apply', query: { auth: 'inbox_denied' } });
        return;
      }
    }
    if (to.meta.clubsAdminOnly) {
      const user = await getCurrentUser();
      if (!emailIsClubsAdmin(user?.email)) {
        next({ name: 'Apply', query: { auth: 'clubs_denied' } });
        return;
      }
    }
  }
  next();
});

router.afterEach((to) => {
  applyDocumentTitle(to);
});

export default router;
